import React, { useState } from 'react';
import { extractTranslation } from '../../services/speechService';
import './MessageBubble.css';

const MessageBubble = ({ 
  children, 
  isUser = false, 
  timestamp,
  status = 'sent', 
  className = '' 
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const { original, translation } = isUser ? { original: children, translation: '' } : extractTranslation(children);
  const hasTranslation = !isUser && translation.trim().length > 0;

  return (
    <div 
      className={`message-bubble ${isUser ? 'message-user' : 'message-other'} ${className}`}
      onMouseEnter={() => hasTranslation && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div className="message-content">
        {original || children}
        
        {showTooltip && hasTranslation && (
          <div className="message-tooltip">
            {translation}
          </div>
        )}
      </div>
      <div className="message-footer">
        <span className="message-time">{timestamp}</span>
        {isUser && (
          <span className={`message-status message-status-${status}`}>
            {status === 'sent' && '✓'}
            {status === 'delivered' && '✓✓'}
            {status === 'read' && '✓✓'}
          </span>
        )}
        {hasTranslation && (
          <span className="message-translation-indicator">
            {showTooltip ? '🇺🇸' : '🇨🇳'}
          </span>
        )}
      </div>
    </div>
  );
};

export default MessageBubble; 